export default "__VITE_ASSET__CoWw1X1P__"